import { render, staticRenderFns } from "./ripsUrgencia.vue?vue&type=template&id=08f5252f&scoped=true&"
import script from "./ripsUrgencia.vue?vue&type=script&lang=js&"
export * from "./ripsUrgencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5252f",
  null
  
)

export default component.exports